module.exports = __webpack_public_path__ + "img/KMRT_logo.6b44b0bc.png";